const PhoneIcon = ({color, width, height}) => {
  return (
    <svg
      width={width ? width : "26"}
      height={height ? height : "25"}
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6323 22.4291C15.0076 22.2388 14.3924 21.9702 13.7866 21.6235L13.7198 21.585C11.6359 20.3713 9.66417 18.2306 7.80465 15.1632C7.41422 14.5191 7.06344 13.8914 6.75232 13.2801C5.1384 10.1092 4.59172 7.37925 5.11213 5.09083C5.35315 4.03098 6.113 3.18163 7.13751 2.80426L7.42329 2.71324L8.59658 2.39606C9.6132 2.12124 10.7082 2.5759 11.2545 3.46914L11.3705 3.68293L12.3593 5.75272C12.6512 6.36361 12.6498 7.04109 12.3883 7.61169C12.3362 7.72536 12.2738 7.83479 12.2013 7.9386C12.1525 8.00849 12.0992 8.07583 12.0414 8.14022L11.8736 8.30722L9.98916 9.98633C10.1326 11.1734 10.5162 12.3156 11.14 13.4129C11.6747 14.3536 12.3151 15.1366 13.061 15.762L13.4428 16.0616L16.067 15.2726C16.9314 15.0127 17.8851 15.2876 18.5017 15.9539L18.6612 16.1452L20.0423 17.9883C20.6901 18.8527 20.6493 20.0039 19.9719 20.7649L19.8171 20.9217L18.9388 21.7243C18.068 22.5199 16.8102 22.7881 15.6323 22.4291Z"
        fill={color ? color : "#F5F5F5"}
      />
    </svg>
  );
};

export default PhoneIcon;
